import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src="/logo-slatech.png" alt="Slatech Solutions" className="h-11 w-auto object-contain" />
            <p className="mt-4 text-zinc-400 text-sm leading-relaxed max-w-xs">
              Alberta- and Texas-based industrial solutions and business development — connecting
              customers with trusted manufacturers, suppliers, and contractors across North America.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-blue-500 mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/partners", label: "Partners" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    className="text-zinc-300 hover:text-white transition-colors duration-200 text-sm font-heading uppercase tracking-widest"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-blue-500 mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-zinc-300">
                <span className="text-blue-500 mt-0.5"><MapPin size={18} /></span>
                Alberta | Texas
              </li>
              <li>
                <a
                  href="mailto:adam@slatechsolutions.com"
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-zinc-300 hover:text-white transition-colors duration-200"
                >
                  <span className="text-blue-500 mt-0.5"><Mail size={18} /></span>
                  adam@slatechsolutions.com
                </a>
              </li>
              <li>
                <a
                  href="tel:7802673294"
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-zinc-300 hover:text-white transition-colors duration-200"
                >
                  <span className="text-blue-500 mt-0.5"><Phone size={18} /></span>
                  780-267-3294
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-zinc-500 text-xs tracking-wide">
            © {new Date().getFullYear()} Slatech Solutions. All rights reserved.
          </p>
          <p className="text-zinc-500 text-xs uppercase tracking-[0.2em] font-heading">
            Backed by Trust.
          </p>
        </div>
      </div>
    </footer>
  );
};
